import React from 'react';

class QuestionMark extends React.Component {
  render() {
    return (
      <svg viewBox="0 0 36 36">
        <path d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2zm.047 26.876a2.69 2.69 0 1 1 0-5.375 2.62 2.62 0 0 1 2.8 2.67 2.581 2.581 0 0 1-2.8 2.705zm3.566-12.818l-.2.21c-.789.829-1.684 1.768-1.684 2.351a2.772 2.772 0 0 0 .358 1.348l.146.278-.113.429a.617.617 0 0 1-.567.377h-2.682a.868.868 0 0 1-.65-.235 4.113 4.113 0 0 1-.845-2.524c0-1.678.934-2.714 2.225-4.15.2-.219.391-.42.575-.61.629-.65 1.014-1.07 1.014-1.515 0-.307 0-1.244-1.786-1.244a5.916 5.916 0 0 0-3.159.919.6.6 0 0 1-.653-.02l-.236-.169-.056-.443v-2.9a.879.879 0 0 1 .394-.82 8.271 8.271 0 0 1 4.3-1.1c3.291 0 5.5 2.118 5.5 5.272a6.134 6.134 0 0 1-1.881 4.546z"></path>
      </svg>
    );
  }
}

class AlertNotice extends React.Component {
  render() {
    return (
      <svg viewBox="0 0 32 32">
        <title>alert-notice</title>
        <path d="M16 2.14l-16 27.72h32l-16-27.72zM16 6.14l12.48 21.6h-24.96l12.48-21.52zM14.96 24h2v2h-2zM14.96 12.1h2v10h-2z"></path>
      </svg>
    );
  }
}

export { QuestionMark, AlertNotice };
